const STYLE = {
    width: '100%',
    fontSize: "0.9em",
    textAlign: 'center'
};
const STYLE_BOTTOM_LEFT_GRID = (dark) => {
    let styles = { textAlign: 'left' };
    styles["borderRight"] = dark ? '1px solid #4a4a4a' : '1px solid #dedede';
    styles["backgroundColor"] = dark ? '#27292d' : '#f7f7f7';
    return styles;
};
const STYLE_TOP_LEFT_GRID = (dark) => {
    let styles = { fontWeight: 'bold',  textAlign: 'center' };
    styles["borderBottom"] = dark ? '1px solid #4a4a4a' : '1px solid #dedede';
    styles["borderRight"] = dark ? '1px solid #4a4a4a' : '1px solid #dedede';
    return styles;
};
const STYLE_TOP_RIGHT_GRID = (dark) => {
    let styles = { fontWeight: 'bold' };
    styles["borderBottom"] = dark ? '1px solid #4a4a4a' : '1px solid #dedede';
    return styles;
};
const STYLE_ROWS = (dark, rowIndex, overrideBackground) => {
    let styles = { height: "100%", lineHeight: "25px" };
    if (overrideBackground)
        styles["background"] = rowIndex % 2 === 0 ? (dark ? "#343438" : "#fff") : (dark ? "#27292d" : "#fbfbfb");
    return styles;
};

export { STYLE, STYLE_BOTTOM_LEFT_GRID, STYLE_TOP_LEFT_GRID, STYLE_TOP_RIGHT_GRID, STYLE_ROWS }